/**
 * The signed-in user's id (email local part), set by getUserToken. Lets
 * non-React modules such as the grid CRUDHandler attribute writes without
 * importing the Redux store.
 */
let currentUserId = "";

export function setCurrentUserId(userId) {
  currentUserId = userId || "";
}

export function getCurrentUserId() {
  return currentUserId;
}
